module.exports = __webpack_public_path__ + "static/media/W06F0005N0000.fb226c6c.svg";